import factory from './icon';
import mail from './glyphs/mail.svg';

export default factory(mail);
